import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";
import { styled } from "@mui/material/styles"; 
import React from "react";

import "./alertAccount.scss";
function AlertDDA(props) {
  const {
    handleClose,
    isOpen,
    firstText,
    title,
    hideDoneButton,
    children,
  } = props;

  const StyledDialog = styled(Dialog)(() => ({
    "& .MuiDialog-scrollPaper": {
      padding: "0 16px",
    },
    "& .MuiDialog-paperFullWidth": {
      minWidth: "100%",
    },
  }));
  return (
    <StyledDialog
      fullWidth
      open={isOpen}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <div className="popup-DDA-container">
        <DialogTitle sx={{ padding: "10px" }}>
          <Typography
            sx={{
              fontSize: "20px",
              fontWeight: "700",
              lineHeight: 1.4, //28px
              color: "#000",
            }}
          >
            {title}
          </Typography>
        </DialogTitle>
        <DialogContent
          sx={{ flex: "1 1 auto", padding: "0px 10px 30px", overflowY: "auto" }}
        >
          <Typography sx={{ color: "#333" }}>{firstText}</Typography>
        </DialogContent>

        <DialogActions sx={{ margin: "0px", padding: "0px" }}>
          {hideDoneButton ? null : (
            <div>
              <button className="button-action-dda" onClick={handleClose}>
                OK
              </button>
            </div>
          )}
          {children}
        </DialogActions>
      </div>
    </StyledDialog>
  );
}
export default AlertDDA;